import { connect } from 'react-redux'

import LifeCycleSection from 'components/home-page/views/sections/life-cycle'

const mapStateToProps = (state, ownProps) => ({
  meta: state.homePageRevision.revision.sections[ownProps.sectionId].meta,
  theme: state.homePageRevision.revision.sections[ownProps.sectionId].theme
})

export default connect(mapStateToProps)(LifeCycleSection)
